/**
 * Internal SPA paths: absolute path on current origin (not protocol-relative).
 */
export function isInternalRedirectPath(url: string): boolean {
  const trimmed = url.trim();
  return trimmed.startsWith('/') && !trimmed.startsWith('//');
}

/**
 * True if `url` is http(s) and its origin matches a whitelist entry.
 * Whitelist items are absolute URLs (e.g. https://tammi.vn); path "/" allows any path on that origin.
 */
export function isWhitelistedExternalRedirect(url: string, whitelist: readonly string[]): boolean {
  if (!/^https?:\/\//i.test(url.trim())) {
    return false;
  }
  let parsed: URL;
  try {
    parsed = new URL(url.trim());
  } catch {
    return false;
  }
  if (parsed.protocol !== 'http:' && parsed.protocol !== 'https:') {
    return false;
  }

  return whitelist.some((allowed) => {
    try {
      const base = new URL(allowed.trim());
      if (parsed.protocol !== base.protocol || parsed.host !== base.host) {
        return false;
      }
      if (base.pathname === '/' || base.pathname === '') {
        return true;
      }
      const prefix = base.pathname.endsWith('/') ? base.pathname : `${base.pathname}/`;
      return parsed.pathname === base.pathname || parsed.pathname.startsWith(prefix);
    } catch {
      return false;
    }
  });
}
